import { inject, Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import {
  ActivatedRouteSnapshot,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { Observable } from 'rxjs';
import { Shoutout, shoutoutConverter } from '../models/shoutout.model';
import { AuthService } from './auth.service';
import {
  Firestore,
  collection,
  collectionData,
  orderBy,
  query,
  where,
} from '@angular/fire/firestore';

@Injectable({
  providedIn: 'root',
})
export class ShoutoutsResolverService {
  private firestore = inject(Firestore);

  constructor(
    private afs: AngularFirestore,
    private router: Router,
    private auth: AuthService,
  ) {}

  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<(Shoutout | undefined)[]> {
    const eventId = route.parent?.paramMap.get('eventId');
    let paid = route.data['paid'];
    let moderated = route.data['moderated'];
    let approved = route.data['approved'];
    let announced = route.data['announced'];

    const shoutoutCollectionRef = collection(
      this.firestore,
      'shoutouts',
    ).withConverter(shoutoutConverter);

    const q = query(
      shoutoutCollectionRef,
      where('eventId', '==', eventId),
      where('paid', '==', paid),
      where('moderated', '==', moderated),
      where('approved', '==', approved),
      where('announced', '==', announced),
      orderBy('createdAt', 'asc'),
    );

    return collectionData(q, { idField: 'id' });

    // return this.afs
    //   .collection<Shoutout>('shoutouts', (ref) =>
    //     ref
    //       .where('eventId', '==', eventId)
    //       .where('paid', '==', paid)
    //       .where('moderated', '==', moderated)
    //       .where('approved', '==', approved)
    //       .where('announced', '==', announced)
    //       .orderBy('createdAt', 'asc'),
    //   )
    //   .valueChanges({ idField: 'id' });
  }
}
